module.exports = __webpack_public_path__ + "img/title-zh.ed180d2f.png";